import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircleIcon } from "components";

export const IntegrationItem = ({
  label,
  logo,
  isChecked,
  onClick,
}: {
  label: string;
  logo: string;
  isChecked: boolean;
  onClick: () => void;
}) => {
  const theme = useTheme();
  return (
    <Stack
      p="10px 16px"
      gap="8px"
      borderRadius="8px"
      border={`1px solid ${
        isChecked ? theme.palette.primary.main : theme.palette.neutral["015"]
      }`}
      bgcolor={isChecked ? theme.palette.neutral["B-005"] : "transparent"}
      direction={"row"}
      alignItems={"center"}
      sx={{
        cursor: "pointer",
        userSelect: "none",
        transition: "all 0.3s",
        ":hover": {
          bgcolor: theme.palette.neutral["B-005"],
        },
      }}
      onClick={onClick}
    >
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={logo}
          alt={`${label} logo`}
          style={{
            width: "32px",
            height: "32px",
            objectFit: "contain",
            borderRadius: "50%",
            border: `1px solid ${theme.palette.neutral["010"]}`,
          }}
        />
      </Stack>

      <Typography variant="body-medium" color={theme.palette.lightBg.low}>
        {label}
      </Typography>
      <CheckCircleIcon
        style={{
          width: "20px",
          height: "20px",
          marginTop: "2px",
          visibility: isChecked ? "visible" : "hidden",
          marginLeft: "auto",
        }}
        color="primary"
      />
    </Stack>
  );
};
